module.exports = __webpack_public_path__ + "media/images/athletes/2761-0cf63b62943dec2f1013cc34703ea4a3.png";